// useRouterPath.js
'use client';
import config from '@/api/global';
import { useLocale } from 'next-intl';
// import config from '@/api/global';

export default function findLocale() {
  const locale = useLocale();

  if (locale == config.defaultLocale) {
    return ``;
  } else {
    return `/${locale}`;
  }
}
